export const MAX_ALLOWED_EMAILS = 10;

export const EmailInviteValidationError = {
	INVALID_FORMAT: 'INVALID_FORMAT',
	DUPLICATE: 'DUPLICATE',
	MAX_ALLOWED_EXCEEDED: 'MAX_ALLOWED_EXCEEDED',
} as const;

export type EmailInviteValidationError =
	(typeof EmailInviteValidationError)[keyof typeof EmailInviteValidationError];

export type AddEmailResult = { ok: true } | { ok: false; error: EmailInviteValidationError };

export interface UseEmailInvitesInputOptions {
	maxAllowedEmails?: number;
}

export interface UseEmailInvitesInput {
	validatedEmails: string[];
	getEmails: () => string[];
	addEmail: (email: string) => AddEmailResult;
	removeEmail: (email: string) => void;
	reset: () => void;
}

export type UseEmailInvitesInputHook = (
	options?: UseEmailInvitesInputOptions,
) => UseEmailInvitesInput;
